export default {
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '800px',
    minHeight: '600px'
  },
  phoneNumbersContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minHeight: '600px'
  },
  radioButtonsContainer: {
    display: 'flex',
    paddingLeft: '28px',
    marginTop: '20px',
    flexGrow: 1
  },
  radioButtons: {
    marginLeft: '30px'
  },
  mobileNumberContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  mobileNumber: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '150px',
    marginLeft: '20px',
    padding: '0 10px',
    border: '1px solid #EBEDF2',
    minHeight: '20px'
  },
  clearIcon: {
    marginLeft: '6px',
    cursor: 'pointer',
    color: '#74788d',
    fontSize: '16px'
  },
  hidden: {
    display: 'none'
  },
  atLeastOneError: {
    color: '#fd397a',
    fontSize: '12px',
    paddingLeft: '28px',
    marginTop: '4px'
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    borderTop: '1px solid #EBEDF2',
    padding: '10px',
    marginTop: 'auto',
    '& button': {
      margin: '10px'
    }
  }
};

export const customStyles = {
  select: {
    value: {
      width: '245px'
    },
    label: {
      paddingLeft: '20px'
    }
  }
};
